import { useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const empty = { name: '', email: '', phone: '', preferredDate: '', preferredTime: '', businessType: '', message: '', vertical: '' };

export default function RequestDemoModal({ show, onHide }) {
  const [form, setForm] = useState(empty);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [serverError, setServerError] = useState('');

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const close = () => {
    onHide();
    setTimeout(() => { setForm(empty); setErrors({}); setDone(false); setServerError(''); }, 300);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = {};
    if (!form.name.trim()) next.name = 'Please tell us your name';
    if (!/\S+@\S+\.\S+/.test(form.email)) next.email = 'Enter a valid email';
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    setSubmitting(true);
    setServerError('');
    try {
      await axios.post(`${API_BASE_URL}/api/demo-requests`, {
        vertical: form.vertical || undefined,
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim() || undefined,
        preferredDate: form.preferredDate || undefined,
        preferredTime: form.preferredTime || undefined,
        businessType: form.businessType.trim() || undefined,
        message: form.message.trim() || undefined
      });
      setDone(true);
    } catch (err) {
      setServerError(err.response?.data?.msg || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title>Request a demo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {done ? (
          <Alert variant="success" className="mb-0">
            Thanks — our team will reach out to schedule a walkthrough.
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit} noValidate>
            {serverError && <Alert variant="danger">{serverError}</Alert>}
            <Row className="g-2">
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-0">Your name *</Form.Label>
                  <Form.Control size="sm" value={form.name} onChange={set('name')} isInvalid={!!errors.name} />
                  <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-0">Email *</Form.Label>
                  <Form.Control size="sm" type="email" value={form.email} onChange={set('email')} isInvalid={!!errors.email} />
                  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-0">Phone</Form.Label>
                  <Form.Control size="sm" value={form.phone} onChange={set('phone')} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-2">
                  <Form.Label className="small mb-0">Vertical</Form.Label>
                  <Form.Select size="sm" value={form.vertical} onChange={set('vertical')}>
                    <option value="">Any</option>
                    <option value="car_rental">Car rental</option>
                    <option value="jewelry">Jewellery</option>
                    <option value="real_estate">Real estate</option>
                    <option value="hospitality">Hospitality</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="small mb-0">How can we help?</Form.Label>
                  <Form.Control size="sm" as="textarea" rows={2} value={form.message} onChange={set('message')} />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2">
              <Button size="sm" variant="outline-secondary" onClick={close}>Cancel</Button>
              <Button size="sm" type="submit" disabled={submitting}>{submitting ? 'Sending…' : 'Request demo'}</Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}
